// ========================================
// Class Service
// Handles all class session operations
// ========================================

const ClassService = {
    /**
     * Get all classes
     */
    getClasses() {
        return DataManager.getAll(DataManager.KEYS.CLASSES);
    },

    /**
     * Get class by ID
     */
    getClass(id) {
        return DataManager.getById(DataManager.KEYS.CLASSES, id);
    },

    /**
     * Get classes by professor
     */
    getClassesByProfessor(professorId) {
        return this.getClasses().filter(c => c.professorId === professorId);
    },

    /**
     * Get classes by formation
     */
    getClassesByFormation(formationId) {
        return this.getClasses().filter(c => c.formationId === formationId);
    },

    /**
     * Get classes by subject
     */
    getClassesBySubject(subjectId) {
        return this.getClasses().filter(c => c.subjectId === subjectId);
    },

    /**
     * Create new class
     */
    createClass(data) {
        const classSession = {
            id: Utils.generateUUID(),
            subjectId: data.subjectId,
            formationId: data.formationId,
            professorId: data.professorId,
            dayOfWeek: parseInt(data.dayOfWeek),
            startTime: data.startTime,
            endTime: data.endTime,
            classroom: data.classroom || '',
            startDate: data.startDate,
            endDate: data.endDate || null,
            color: data.color || null,
            createdAt: new Date().toISOString()
        };
        return DataManager.add(DataManager.KEYS.CLASSES, classSession);
    },

    /**
     * Update class
     */
    updateClass(id, data) {
        return DataManager.update(DataManager.KEYS.CLASSES, id, data);
    },

    /**
     * Delete class
     */
    deleteClass(id) {
        return DataManager.delete(DataManager.KEYS.CLASSES, id);
    },

    /**
     * Get class with full details (subject, formation, professor)
     */
    getClassWithDetails(id) {
        const classSession = this.getClass(id);
        if (!classSession) return null;

        const subject = SubjectService.getSubject(classSession.subjectId);
        const formation = FormationService.getFormation(classSession.formationId);
        const professor = ProfessorService.getProfessor(classSession.professorId);

        return {
            ...classSession,
            subject,
            formation,
            professor
        };
    },

    /**
     * Get classes for a specific day of week
     */
    getClassesByDay(dayOfWeek) {
        return this.getClasses().filter(c => c.dayOfWeek === parseInt(dayOfWeek));
    },

    /**
     * Calculate duration of a class in hours
     */
    getClassDuration(classId) {
        const classSession = this.getClass(classId);
        if (!classSession) return 0;

        return Utils.calculateDuration(classSession.startTime, classSession.endTime);
    }
};

// Make ClassService globally available
window.ClassService = ClassService;
